<template>
    <templateBase module-name="Relatórios" :title="pageInfos.title" :subtitle="pageInfos.subtitle">
        <template #sidebar-left><side-menu /></template>
        <template #page><router-view /></template>
    </templateBase>
</template>

<script>
import templateBase from '@/templates/page-configurations'

import sideMenu from './components/side-menu'

export default {
	name: 'ui-reports-basics',

	components: { templateBase, sideMenu },

	data() {
		return {
			pageInfos: {},
		}
	},

	watch: {
		$route(to, from) {
			if (to != from) {
				this.pageInfos = to.meta.infos
				this.prepareSubtitle(to.params.title)
			}
		},
	},

	created() {
		this.pageInfos = this.$route.meta.infos
		this.prepareSubtitle(this.$route.params.title)
	},

	methods: {
		prepareSubtitle(title) {
			if (this.$route.name != 'reports.basics.all')
				this.pageInfos.subtitle =
					'Relatórios de ' + title.charAt(0).toUpperCase() + title.slice(1)
		},
	}
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>
